import { useEffect, useRef, useState, useTransition } from 'react';

import { fetchRounding } from '~modules/rounding/api';
import { RoundingErrorDto } from '~modules/rounding/dto';

export function useRounding() {
	const [data, setData] = useState<RoundingErrorDto>();
	const [pending, startLoading] = useTransition();
	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			startLoading(async () => {
				const data = await fetchRounding();
				setData(data);
			});
		}
	}, []);

	return { pending, data };
}
